import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InvoiceItemComponent, FilteredSiteEntry } from '../invoice-item/invoice-item.component';
import { TableUtil } from '../../../../tableUtil';
import { TranslatorService } from '../../../../services/translator_service';

@Component({
  selector: 'app-invoice-list',
  standalone: true,
  imports: [CommonModule, TranslateModule, InvoiceItemComponent],
  templateUrl: './invoice-list.component.html',
  styleUrl: './invoice-list.component.scss'
})
export class InvoiceListComponent {
  @Input() entries: FilteredSiteEntry[] = [];
  @Input() period = '';
  @Input() grandTotal = '';

  constructor(private translator: TranslatorService) {}

  exportToExcel(): void {
    const isHebrew = this.translator.translate.currentLang === 'iw';
    const sheetsByEventType = new Map<string, object[]>();

    for (const entry of this.entries) {
      for (const event of entry.events) {
        const row = {
          [isHebrew ? 'אתר'            : 'Site']:          entry.site.siteName,
          [isHebrew ? 'מזהה פח'        : 'Bin']:           event.bin,
          [isHebrew ? 'סוג פח'         : 'Bin Type']:      event.binType,
          [isHebrew ? 'תאריך'          : 'Date']:          event.date,
          [isHebrew ? 'יחידות'         : 'Units']:         event.units,
          [isHebrew ? 'כתובת'          : 'Address']:       event.address,
          [isHebrew ? 'חוזה'           : 'Contract']:      event.contract,
          [isHebrew ? 'סכום'           : 'Amount']:        event.amount,
        };

        const eventTypeName = event.eventType || (isHebrew ? 'ללא סוג אירוע' : 'Other');
        let eventTypeRows = sheetsByEventType.get(eventTypeName);
        if (!eventTypeRows) {
          eventTypeRows = [];
          sheetsByEventType.set(eventTypeName, eventTypeRows);
        }
        eventTypeRows.push(row);
      }
    }

    const sheets = Array.from(sheetsByEventType.entries()).map(([name, rows]) => ({ name, rows }));
    TableUtil.exportSheetsToExcel(sheets, isHebrew ? 'חשבוניות' : 'Invoices', this.exportPeriod());
  }

  private exportPeriod(): string {
    const period = (this.period || '').trim();
    if (!period) { return ''; }
    const parts = period.split('\u2013').map(part => part.trim());
    if (parts.length == 2 && parts[0] == parts[1]) { return parts[0]; }
    return period;
  }
}
